import React from 'react';
import Svg from '../../images/ilustrations/Anye_vistas_barco3_new.svg';

const AnyeVistasBarco3 = () => (
    <img src={Svg} alt="Barco" style={{ width: '2em', height: '2em', transform: 'rotate(90deg)', transformOrigin: 'center' }} />
);

export default AnyeVistasBarco3;
